const firebaseConfig = {
	apiKey: "AIzaSyD1Bk8KUTYHhpBNJZa4ITudvFPc5o_Yc-0",
	authDomain: "dark-thunder007.firebaseapp.com",
	projectId: "dark-thunder007",
	storageBucket: "dark-thunder007.appspot.com",
	messagingSenderId: "286621850633",
	appId: "1:286621850633:web:118fff2a384d38143cecd8",
	// apiKey: process.env.REACT_APP_API_KEY,
	// authDomain: process.env.REACT_APP_AUTH_DOMA_IN,
	// projectId: process.env.REACT_APP_PROJECT_ID,
	// storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	// messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	// appId: process.env.REACT_APP_APP_ID,
};
export default firebaseConfig;
